module.exports = __webpack_public_path__ + "static/media/IconError.f61dcb3a.svg";